import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { AllFlags } from '@growthBookExperimentation/Entities/FlagKeys.entities';

export function getEnabledToggleConfig({
  flags: _flags,
  tenant,
}: {
  tenant?: Tenant;
  flags: AllFlags;
}) {
  return {
    ecom: false,
    eligibleProductsUk: false,
    eligibleProductsFr: false,
    partnerRac: tenant === 'rac',
  };
}
